module.exports = __webpack_public_path__ + "static/img/mutual-fund-header.c8bc509.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/mutual-fund-header.svg
// module id = mOgO
// module chunks = 5